import * as React from "react";
import { Link } from "react-router-dom";
import { LoadIntakeStrategies } from "../../../../actions/ISActions";
import IntakeStrategyStore from "../../../../stores/IntakeStrategyStore";
class IntakeStrategySidebar extends React.Component {
  //isList: Array<BPModel>;
  constructor(props) {
    super(props);
    this.state = {
      isList: [],
      currentIs: void 0
    };
    this.LoadStrategies = this.LoadStrategies.bind(this);
    this.onISChange = this.onISChange.bind(this);
  }
  LoadStrategies() {
  }
  componentDidMount() {
    IntakeStrategyStore.addChangeListener(this.onISChange);
    let isList = IntakeStrategyStore.getIntakeStrategies();
    if (isList === void 0) {
      LoadIntakeStrategies();
    } else {
      this.setState({ isList: IntakeStrategyStore.getIntakeStrategies() });
    }
  }
  componentWillUnmount() {
    IntakeStrategyStore.removeChangeListener(this.onISChange);
  }
  onISChange() {
    let list = IntakeStrategyStore.getIntakeStrategies();
    this.setState({ isList: list });
  }
  handleBPClick(bp) {
  }
  handleImportLink() {
  }
  render() {
    let bpSection;
    if (this.state.currentIs !== void 0) {
      bpSection = /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", { className: "fs-3", style: { marginBottom: "10px" } }, this.state.currentIs.isName, " "), /* @__PURE__ */ React.createElement("hr", null));
    }
    let listOfISs;
    if (this.state.isList !== void 0) {
      listOfISs = this.state.isList.map((intake) => /* @__PURE__ */ React.createElement(
        Link,
        {
          className: "sidebar-link",
          to: "/Admin/IntakeStrategies/" + intake.id,
          key: intake.id,
          style: { cursor: "Pointer" }
        },
        intake.isName
      ));
    } else {
      listOfISs = /* @__PURE__ */ React.createElement("div", null);
    }
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "d-flex flex-column p-3 text-white bg-dark",
        style: { height: "100%", width: "245px" }
      },
      /* @__PURE__ */ React.createElement(
        Link,
        {
          to: "/v/administration/intakeStrategies",
          className: "d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none"
        },
        /* @__PURE__ */ React.createElement("span", { className: "fs-4" }, /* @__PURE__ */ React.createElement(
          "i",
          {
            className: "fa-regular fa-file-import",
            style: { color: "#4EE8E8" }
          }
        ), "   ", "Intake Strategies")
      ),
      /* @__PURE__ */ React.createElement("hr", null),
      bpSection,
      listOfISs,
      /* @__PURE__ */ React.createElement("hr", null),
      /* @__PURE__ */ React.createElement(Link, { to: "/Admin/IntakeStrategies/new", className: "sidebar-link" }, "New Intake Strategy")
    );
  }
}
export default IntakeStrategySidebar;
